/* eslint-disable quotes */
/* eslint-disable semi */
import httpClient from '@/utils/http-client.js';
import { storeActions } from '@store/actions.constants';
import { storeMutations } from '@store/mutations.constants';

const userActions = {
  [storeActions.getDemoPaidUsers]: ({ commit }, payLoad) => {
    debugger
    console.log(payLoad);
    return httpClient.get('/analytics/demo-paid/users', payLoad).then(
      (res) => {
        console.log(res);

        commit(storeMutations.setDemoPaidUsers, res);
        return res;
      },
      (err) => {
        commit(storeMutations.setDemoPaidUsers, err);
        return err.response;
      },
    );
  },
  [storeActions.getAgencyOwnUsers]: ({ commit }, payLoad) => {
    debugger
    console.log(payLoad);
    return httpClient.get('/analytics/agency-own/users', payLoad).then(
      (res) => {
        console.log(res);

        commit(storeMutations.setAgencyOwnUsers, res);
        return res;
      },
      (err) => {
        commit(storeMutations.setAgencyOwnUsers, err);
        return err.response;
      },
    );
  },
  [storeActions.getDesignationById]: ({ commit }, payLoad) => {
    console.log(payLoad.id);
    return httpClient.get('/designation/getById/' + payLoad.id).then(
      (res) => {
        console.log(res);

        commit(storeMutations.designationMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.designationMutation, err);
        return err.response;
      },
    );
  },

  [storeActions.updateDesignationById]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/designation/update', payLoad).then(
      (res) => {
        console.log(res);

        // commit(storeMutations.designationMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.designationMutation, err);
        return err.response;
      },
    );
  },
};
export default { ...userActions };